import { gql } from '@apollo/client'
import employeeDisplayFragment from '../../employee/fragments/employeeDisplay.fragment'
import employeeDisplayShortInfoFragment from '../../employee/fragments/employeeDisplayShortInfo.fragment'
import meetingCoreFragment from './meetingCore.fragment'
import appraisalSeasonFragment from './appraisalSeason.fragment'

export default gql`
  fragment MeetingDashboard on Meeting {
    ...MeetingCore
    employee {
      ...EmployeeDisplay
    }
    reviewer {
      ...EmployeeDisplayShortInfo
    }
    managerPrepared
    employeePrepared
    meetingSteps {
      id
      viewId
      type
    }
    conclusionPdfStatus
    conclusionPdfFileName
    conclusionPdfDownloadToken
    preparationPdfFileName
    preparationPdfDownloadToken
    appraisal {
      shareWithHR
      feedbackForHR
      hrResult
    }
    other {
      agenda
    }
    nonParticipants {
      id
      firstName
      lastName
      businessUnit {
        id
        name
      }
    }
    ...AppraisalSeason
  }
  ${meetingCoreFragment}
  ${employeeDisplayFragment}
  ${employeeDisplayShortInfoFragment}
  ${appraisalSeasonFragment}
`
